import { queryOptions, useMutation } from '@tanstack/react-query'

import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'

import { AUTH_USER_KEY } from './auth.constants'
import {
  fetchMe,
  forgotPasswordRequest,
  resetPasswordRequest,
  signInRequest,
} from './auth.service'
import type {
  TAuthUser,
  TForgotPasswordRequest,
  TResetPasswordRequest,
  TSignInRequest,
  TTokens,
} from './auth.types'

export function authUserQueryOptions() {
  return queryOptions<TAuthUser>({
    queryKey: AUTH_USER_KEY,
    queryFn: fetchMe,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  })
}

export function useSignIn(
  callbacks: TMutation<TTokens, TResponseError, TSignInRequest>
) {
  return useMutation<TTokens, TResponseError, TSignInRequest>({
    mutationFn: signInRequest,
    onSuccess: callbacks.onSuccess,
    onError: callbacks.onError,
  })
}

export function useForgotPassword(
  callbacks: TMutation<void, TResponseError, TForgotPasswordRequest>
) {
  return useMutation<void, TResponseError, TForgotPasswordRequest>({
    mutationFn: forgotPasswordRequest,
    onSuccess: callbacks.onSuccess,
    onError: callbacks.onError,
  })
}

export function useResetPassword(
  callbacks: TMutation<void, TResponseError, TResetPasswordRequest>
) {
  return useMutation<void, TResponseError, TResetPasswordRequest>({
    mutationFn: resetPasswordRequest,
    onSuccess: callbacks.onSuccess,
    onError: callbacks.onError,
  })
}
